// extracted by mini-css-extract-plugin
module.exports = {"catalogueContainer":"CatalogueBlock_catalogueContainer__3qgIe","grid":"CatalogueBlock_grid__3NYrm","gridItem":"CatalogueBlock_gridItem__i-zQn"};